<template>
    <div class="auth-big-logo">
      <div class="container-fluid">
        <router-link to="/" class="d-flex align-items-center justify-content-center">
          <!-- <img :src="setting.logo.logo ? setting.logo.logo : require('../../assets/logo.png')" alt="" class="img-fluid" /> -->
          <img :src="require('../../assets/logo.png')" alt="" class="img-fluid" />
          <!-- <div class="logo-title pl-2" v-html="setting.logo.title ? setting.logo.title : 'GAEE'"></div> -->
        </router-link>
      </div>
    </div>
</template>

<style scoped src="../../components/common/css/Auth.css">

</style>

<script>
import axios from "axios";

export default {
    name: "AuthHeader",
    components: {
        
    },
    data() {
        return {
            setting: []
        }
    },
    methods: {
        fetchLogo() {
            axios.get(window.baseURL + '/setting')
            .then(res => {
                console.log(res);
                this.setting = res.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    created() {
        this.fetchLogo();
    }
}
</script>